import React, { useState, useEffect } from 'react'
import './ReportCalendar.css'

const daysOfWeek = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom']

interface ReportCalendarProps {
    initialDate: Date
    onDateSelect: (date: Date) => void
    onClose: () => void
}

const ReportCalendar = ({
    initialDate,
    onDateSelect,
    onClose,
}: ReportCalendarProps) => {
    const [currentDate, setCurrentDate] = useState(
        new Date(initialDate.getFullYear(), initialDate.getMonth(), 1)
    )

    useEffect(() => {
        setCurrentDate(
            new Date(initialDate.getFullYear(), initialDate.getMonth(), 1)
        )
    }, [initialDate])

    const year = currentDate.getFullYear()
    const month = currentDate.getMonth()

    const firstDayIndex = new Date(year, month, 1).getDay() // 0 (dom) a 6 (sab)
    const daysInMonth = new Date(year, month + 1, 0).getDate()

    const adjustedStartIndex = firstDayIndex === 0 ? 6 : firstDayIndex - 1

    const prevMonth = () => {
        setCurrentDate(new Date(year, month - 1, 1))
    }

    const nextMonth = () => {
        setCurrentDate(new Date(year, month + 1, 1))
    }

    const getMonthName = (monthIndex: number) => {
        return new Date(0, monthIndex).toLocaleString('es-AR', {
            month: 'long',
        })
    }

    const emptyDays: (number | null)[] = Array.from(
        { length: adjustedStartIndex },
        () => null
    )
    const monthDays: (number | null)[] = Array.from(
        { length: daysInMonth },
        (_, i) => i + 1
    )
    const days: (number | null)[] = [...emptyDays, ...monthDays]

    const handleDateClick = (day: number | null) => {
        if (!day) return
        const selectedDate = new Date(year, month, day)
        onDateSelect(selectedDate)
        onClose()
    }

    return (
        <div className="calendar">
            <div className="calendar-header">
                <button onClick={prevMonth}>{'<'}</button>
                <span>
                    {getMonthName(month).charAt(0).toUpperCase() +
                        getMonthName(month).slice(1)}{' '}
                    {year}
                </span>
                <button onClick={nextMonth}>{'>'}</button>
            </div>

            <div className="calendar-grid">
                {daysOfWeek.map((day) => (
                    <div key={day} className="calendar-day-name">
                        {day}
                    </div>
                ))}
                {days.map((day, index) => (
                    <div
                        key={index}
                        className={`calendar-day${day ? '' : ' empty'}`}
                        onClick={() => handleDateClick(day)}
                        style={{ cursor: day ? 'pointer' : 'default' }}
                    >
                        {day}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ReportCalendar
